import { useCallback } from "react"
import { useQuery } from "urql"

import type { PackagingInfo } from "../types/packaging"

import { type Product, ProductPackagingInformationDocument } from "@/graphql/codegen/graphql"

interface UsePackagingInfoResult {
  data: PackagingInfo | null
  loading: boolean
  error: Error | null
  fetch: (params: UsePackagingInfoProps) => void
}

interface UsePackagingInfoProps {
  productId: number
  version?: number
}

export const usePackagingInfo = ({ productId, version }: UsePackagingInfoProps): UsePackagingInfoResult => {
  const [{ data, fetching: loading, error }, reexecuteQuery] = useQuery({
    query: ProductPackagingInformationDocument,
    variables: { productId, version },
    pause: !productId,
  })

  const fetch = useCallback(
    (params: UsePackagingInfoProps) => {
      reexecuteQuery({
        requestPolicy: "network-only",
        variables: { productId: params.productId, version: params.version },
      })
    },
    [reexecuteQuery]
  )

  const productData = (
    data?.product?.get.__typename === "ProductGetSuccess" ? data.product.get.product : null
  ) as Partial<Product> | null

  return {
    data: productData,
    loading,
    error: error || null,
    fetch,
  }
}
